import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from '~/components/section-title/SectionTitle';

import { KeyValueElement } from './components/KeyValueElement';
import { useKeyValues } from './hooks/use-key-values/useKeyValues';
import styles from './OverviewKeyValues.module.scss';

export interface OverviewKeyValuesProps {
  entityTag: string;
  isDefaultVariant?: boolean;
}

export const OverviewKeyValues = ({
  entityTag,
  isDefaultVariant = true,
}: OverviewKeyValuesProps) => {
  const { t } = useTranslation('widget');

  const { data, isError, isFetching, error } = useKeyValues(entityTag);

  if (isFetching) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '164px',
              borderRadius: '8px',
            },
          },
        ]}
        data-testid="loading-state"
      />
    );
  }

  if (isError) {
    throw error;
  }

  if (!data?.length) {
    return null;
  }

  const filteredData = data.filter(d => d.value_fmt !== undefined);
  return (
    <div
      className={styles.overviewKeyValuesRoot}
      data-testid="overview-key-values"
    >
      {isDefaultVariant && (
        <SectionTitle title={t('widget:assetOverview.keyValuesTitle')} />
      )}
      <div className={styles.keyValuesList} data-key-values-list>
        {filteredData.map(keyValue => (
          <KeyValueElement
            key={keyValue.key}
            keyValue={keyValue}
            isDefaultVariant={isDefaultVariant}
          />
        ))}
      </div>
    </div>
  );
};
